<template>
  <div class="mt-6 overflow-x-auto">
    <table class="w-full table-auto">
      <thead>
      <tr class="text-sm font-semibold text-center border-b-2 border-blue-500 uppercase">
        <template v-for="(value, _, index) in tableColumns" :key='index'>
          <th :class="'px-4 py-3 '+(value['classTitle']?value['classTitle']:'')"
              :style="value['styleTitle']?value['styleTitle']:''" v-if="value.isVisibleInTable">
            {{ value.value }}
          </th>
        </template>
        <th v-if="haveUpdatePermissions||slotHaveUpdatePermissions" class="px-4 py-3">Opciones</th>
      </tr>
      </thead>
      <tbody class="text-sm font-normal text-gray-700 text-center">
      <tr class="py-10 bg-gray-100 hover:bg-gray-200 font-medium"
          v-for="(data, indexCollectionData) of copyCollectionData"
          :key="'A'+indexCollectionData">
        <template v-for="(value, key, index) in tableColumns" :key='index'>
          <td :class="'cell_'+key+' px-4 py-4 '+(value['classValue']?value['classValue']:'')"
              :style="value['styleValue']?value['styleValue']:''"
              v-if="getValueByTableColumns(key, value, key.split('.')[0], true, undefined, index)">
            <span v-if="key === subTableColumn&&selectedData">
              <button
                  v-if="getValueByTableColumns(key, value, key.split('.')[0], false, indexCollectionData, index).filter(element => element.estado).length > 0"
                  @click="$emit('updateValues', {'view': 'sublistar'});updateSelectedValues(
                  Object.keys(collectionData[indexCollectionData])
                  .filter(k=>Object.keys(selectedData).includes(k))
                  .reduce((o, keyValue)=>({...o, [keyValue]: collectionData[indexCollectionData][keyValue]}), {})
                  )"
                  class="px-2 py-2 text-white bg-green-500 rounded-md hover:bg-green-600 focus:outline-none">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-4 w-5 inline"
                    fill="none"
                    viewBox="3 3 16 16"
                    stroke="currentColor"
                >
                  <path
                      d="M10,6.978c-1.666,0-3.022,1.356-3.022,3.022S8.334,13.022,10,13.022s3.022-1.356,3.022-3.022S11.666,6.978,10,6.978M10,12.267c-1.25,0-2.267-1.017-2.267-2.267c0-1.25,1.016-2.267,2.267-2.267c1.251,0,2.267,1.016,2.267,2.267C12.267,11.25,11.251,12.267,10,12.267 M18.391,9.733l-1.624-1.639C14.966,6.279,12.563,5.278,10,5.278S5.034,6.279,3.234,8.094L1.609,9.733c-0.146,0.147-0.146,0.386,0,0.533l1.625,1.639c1.8,1.815,4.203,2.816,6.766,2.816s4.966-1.001,6.767-2.816l1.624-1.639C18.536,10.119,18.536,9.881,18.391,9.733 M16.229,11.373c-1.656,1.672-3.868,2.594-6.229,2.594s-4.573-0.922-6.23-2.594L2.41,10l1.36-1.374C5.427,6.955,7.639,6.033,10,6.033s4.573,0.922,6.229,2.593L17.59,10L16.229,11.373z"
                  />
                </svg>
                <span class="pl-1">
                  (cantidad: {{
                    getValueByTableColumns(key, value, key.split('.')[0], false, indexCollectionData, index).filter(element => element.estado).length
                  }})
                </span>
              </button>
              <span v-else>
                Ninguno
              </span>
            </span>
            <span v-else
                  v-html="key === 'estado' ? (data[key.split('.')[0]] ? 'Activo' : 'Inactivo') : getValueByTableColumns(key, value, key.split('.')[0], false, indexCollectionData, index)"></span>
          </td>
        </template>
        <td v-if="(haveUpdatePermissions || slotHaveUpdatePermissions)&&selectedData" class="px-4 py-4">
          <div class="flex flex-col lg:flex-row lg:space-x-2 items-center space-y-2 lg:space-y-0 justify-center">
            <template v-if="haveUpdatePermissions">
              <button v-if="applyUpdateHidden(data)"
                      @click="$emit('updateValues', {'view': 'actualizar'});updateSelectedValues(
                  Object.keys(collectionData[indexCollectionData])
                  .filter(k=>Object.keys(selectedData).includes(k))
                  .reduce((o, keyValue)=>({...o, [keyValue]: collectionData[indexCollectionData][keyValue]}), {})
                  );customUpdateActions?.map(async action => await action());"
                      class="items-center px-2 py-2 text-white bg-yellow-500 rounded-md hover:bg-yellow-600 focus:outline-none">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                     stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"/>
                </svg>
              </button>
              <template v-if="applyStateHidden(data)">
                <button v-if="!data.estado"
                        @click="enableDisableData(entity, 'activar', data, listApi['updateState'], authToken, customEnableDisableData, primaryKey, customActionButtons)"
                        class="items-center px-2 py-2 text-white bg-blue-500 rounded-md hover:bg-blue-600 focus:outline-none">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                       stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.5 12.75l6 6 9-13.5"/>
                  </svg>
                </button>
                <button v-else
                        @click="enableDisableData(entity, 'desactivar', data, listApi['updateState'], authToken, customEnableDisableData, primaryKey)"
                        class="items-center px-2 py-2 text-white bg-red-500 rounded-md hover:bg-red-600 focus:outline-none">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                       stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                  </svg>
                </button>
              </template>
            </template>
            <slot v-if="slotHaveUpdatePermissions" :data="Object.keys(collectionData[indexCollectionData])
                  .filter(k=>Object.keys(selectedData).includes(k))
                  .reduce((o, key)=>({...o, [key]: collectionData[indexCollectionData][key]}), {})"></slot>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import {copiaProfunda} from "@/common/constants";
import {ref, watch} from "vue";
import {enableDisableData} from "@/layouts/main";
// import {enableDisableData, havePermissions} from "@/layouts/main";


/**
 * Componente de tabla reutilizable que se puede adaptar para mostrar diferentes tipos de datos.
 *
 * @vue/component
 * @name TableComponent
 * @prop {Object} entity - Objeto de entidad que se utiliza para la definición de permisos.
 * @prop {Boolean} isUpdateHidden - Booleano que indica si se oculta o no el botón de actualización en la tabla.
 * @prop {Boolean} isStateHidden - Booleano que indica si se oculta o no la columna de estado en la tabla.
 * @prop {Object} selectedData - Objeto de datos seleccionados que se utilizan para actualizar o eliminar datos en la tabla.
 * @prop {Object} tableColumns - Objeto que contiene las columnas que se muestran en la tabla.
 * @prop {Array} collectionData - Matriz de datos que se muestran en la tabla.
 * @prop {String} authToken - Token de autenticación que se utiliza para realizar solicitudes.
 * @prop {String} listApi - Cadena de la API que se utiliza para recuperar datos de la tabla.
 * @prop {Function} customUpdateSelectedData - Función personalizada que se utiliza para actualizar los datos seleccionados.
 * @prop {Function} customEnableDisableData - Función personalizada que se utiliza para habilitar o deshabilitar los datos de la tabla.
 * @prop {String} primaryKey - Clave principal que se utiliza para actualizar o eliminar datos de la tabla.
 * @prop {Array} customActionButtons - Matriz de botones de acción personalizados que se muestran en la tabla.
 * @prop {Array} customUpdateActions - Matriz de acciones de actualización personalizadas que se muestran en la tabla.
 * @prop {Function} customUpdateCollectionData - Función personalizada que se utiliza para actualizar los datos de la colección.
 * @prop {String} updatePermission - Permiso que se utiliza para actualizar los datos de la tabla.
 * @prop {String} slotUpdatePermission - Permiso que se utiliza para actualizar los datos de la tabla dentro del slot.
 * @prop {Boolean} customStateHidden - Booleano que indica si se oculta o no la columna de estado en la tabla.
 * @prop {Boolean} customUpdateHidden - Booleano que indica si se oculta o no el botón de actualización en la tabla.
 * @prop {Object} subTableColumn - Objeto que contiene las columnas de la subtabla que se muestran en la tabla principal.
 * @emits {Object} updateValues - Evento que se emite cuando se actualizan los valores de la tabla.
 *
 * @example
 * // Para utilizar el componente, importa y registra como un componente de Vue
 * import TableComponent from "@/components/TableComponent.vue";
 *
 * export default {
 *   components: { TableComponent },
 *   // ...
 * }
 */
export default {
  name: 'TableComponent',
  props: ['entity', 'isUpdateHidden', 'isStateHidden', 'selectedData', 'tableColumns', 'collectionData', 'authToken', 'listApi', 'customUpdateSelectedData', 'customEnableDisableData', 'primaryKey', 'customActionButtons', 'customUpdateActions', 'customUpdateCollectionData', 'updatePermission', 'slotUpdatePermission', 'customStateHidden', 'customUpdateHidden', 'subTableColumn'],
  emits: ["updateValues"],
  data: function () {
    return {
      copiaProfunda: copiaProfunda,
      enableDisableData: enableDisableData
    }
  },
  /**
   Configura y actualiza los datos de la colección.
   @async
   @function setup
   @param {Object} props - Objeto de propiedades.
   @param {Array} props.collectionData - Datos de la colección.
   @param {Object} props.tableColumns - Columnas de la tabla.
   @param {Object} [props.selectedData] - Datos seleccionados.
   @param {Function} [props.customUpdateCollectionData] - Función para aplicar customizaciones sobre los datos de la colección.
   @param {String} [props.updatePermission] - Permiso para actualizar.
   @param {String} [props.slotUpdatePermission] - Permiso para actualizar slots.
   @param {String} [props.entity] - Entidad relacionada.
   @returns {Object} Objeto con los datos actualizados y los permisos.
   */
  async setup(props) {
    const copyCollectionData = ref([]);
    const customFunctionsTableColumns = ref({});
    /**
     Actualiza los datos de la colección.
     @function updateCollectionData
     @param {Array} collecionData - Datos de la colección.
     @returns {Array} Resultado de los datos actualizados.
     */
    const updateCollectionData = (collecionData) => {
      let updatedCollectionData;
      // APLICAR FUNCIONES CUSTOM SOBRE COLLECTION DATA
      if (props.customUpdateCollectionData) updatedCollectionData = props.customUpdateCollectionData();
      else updatedCollectionData = copiaProfunda(collecionData);
      let result = [];
      // ORDENAR COLLECTION DATA SEGÚN ORDEN DE TABLE COLUMNS
      const defaultValue = {
        isFilter: false,
        isOrder: false,
        isVisibleInTable: true,
        value: ''
      };
      const fillCustomFunctionsTableColumns = {};
      Object.keys(props.tableColumns).map(column => {
        fillCustomFunctionsTableColumns[column] = {};
        Object.keys(props.tableColumns[column]).map(key => {
          if (typeof props.tableColumns[column][key] === 'function')
            fillCustomFunctionsTableColumns[column][key] = props.tableColumns[column][key];
        });
      });
      customFunctionsTableColumns.value = fillCustomFunctionsTableColumns;
      const tableColumns = copiaProfunda(props.tableColumns);
      if (props.selectedData) {
        const extraKeys = Object.keys(props.selectedData);
        for (const key of extraKeys) {
          if (!(key in tableColumns)) tableColumns[key] = defaultValue;
        }
      }
      for (const collectionData of updatedCollectionData) {
        const value = {};
        for (const key in tableColumns) {
          const keyCollectionData = Object.keys(collectionData).filter(keyCollectionData => key.split('.')[0] === keyCollectionData)[0];
          value[keyCollectionData] = collectionData[keyCollectionData];
        }
        result.push(value);
      }
      return result;
    }
    copyCollectionData.value = updateCollectionData(props.collectionData);
    watch(() => props.collectionData, newCollectionData => copyCollectionData.value = updateCollectionData(newCollectionData));
    let haveUpdatePermissions;
    let slotHaveUpdatePermissions;
  
    if (props.entity) {
      // haveUpdatePermissions = await havePermissions(props.updatePermission).then(res => {
      //   return res
      // });
      // slotHaveUpdatePermissions = await havePermissions(props.slotUpdatePermission).then(res => {
      //   return res
      // });
      haveUpdatePermissions = true;
      slotHaveUpdatePermissions = true;
    }

    return {
      haveUpdatePermissions,
      slotHaveUpdatePermissions,
      copyCollectionData,
      customFunctionsTableColumns
    };
  },
  methods: {
    /**
     Obtiene el valor de una celda de acuerdo a la tabla de columnas y los datos de colección correspondientes.
     @param {string} keyTableColumn - La clave de la columna de la tabla.
     @param {object} valueTableColumn - El objeto de la columna de la tabla.
     @param {string} keyCollectionData - La clave del dato de colección.
     @param {boolean} verifyIsVisibleInTable - Si se debe verificar si la columna es visible en la tabla.
     @param {number} [indexCollectionData=0] - El índice del dato de colección.
     */
    getValueByTableColumns: function (keyTableColumn, valueTableColumn, keyCollectionData, verifyIsVisibleInTable, indexCollectionData = 0) {
      if (verifyIsVisibleInTable) return valueTableColumn['isVisibleInTable'];

      else {
        if (keyTableColumn.split('.').length > 1) {
          const value = this.copyCollectionData[indexCollectionData];
          return keyTableColumn.split('.').reduce((result, keyByDot) => {
            if(result !== null)
              result = result[keyByDot];
            return result;
          }, value);
        } else{
          
          if(keyTableColumn == 'cuentasFuentesMacro'){
            const value = this.copyCollectionData[indexCollectionData].cuentasFuentesMacro;
              if (value.length > 0) {
                return value[0].macroFuente.nombre;
              }else{
                return '';
              }
          }
          return this.copyCollectionData[indexCollectionData][keyCollectionData];
        }
      }
    },
    /**
     Actualiza los valores seleccionados en el componente.
     @param {object} data - Los datos seleccionados.
     */
    updateSelectedValues: function (data) {
      if (this.customUpdateSelectedData) this.customUpdateSelectedData(data);
      else this.$emit('updateValues', {'selectedData': data});
    },
    /**
     Verifica si se debe ocultar las opciones de actualizar en el componente.
     @param {object} data - Los datos del componente.
     @returns {boolean} true si se debe de ocultar las opciones de actualizar; de lo contrario, false.
     */
    applyUpdateHidden: function (data) {
      if (this.customUpdateHidden)
        return this.customUpdateHidden ? this.customUpdateHidden(data) : !this.customUpdateHidden;
      return !this.isUpdateHidden;
    },
    /**
     Verifica si se debe ocultar las opciones de cambio de estado en el componente.
     @param {object} data - Los datos del componente.
     @returns {boolean} true si se debe ocultar las opciones de cambio de estado; de lo contrario, false.
     */
    applyStateHidden: function (data) {
      if (this.customStateHidden)
        return (this.customStateHidden ? this.customStateHidden(data) : !this.customStateHidden) && 'estado' in data;
      return !this.isStateHidden && 'estado' in data;
    }
  },
  mounted() {
    /**
     Función que se encarga de actualizar las clases y estilos de las celdas de la tabla.
     @function
     @name updateStylesClass
     @memberof mounted
     @returns {void}
     */
    const updateStylesClass = () => {
      this.$nextTick(() => {
        for (const mode of ['clear', 'add']) {
          for (const key in this.tableColumns) {
            const elementsHTML = document.getElementsByClassName('cell_' + key);
            for (const elementHTML of elementsHTML) {
              if (this.customFunctionsTableColumns[key]['customCallbackClassValue']) {
                const value = this.customFunctionsTableColumns[key]['customCallbackClassValue'](elementHTML.innerText);
                if (mode === 'add')
                  elementHTML.className += ' ' + value;
                else elementHTML.className = elementHTML.className.replaceAll(value, '');
              }
              if (this.customFunctionsTableColumns[key]['customCallbackStyleValue']) {
                const value = this.customFunctionsTableColumns[key]['customCallbackStyleValue'](elementHTML.innerText);
                const currentStyle = elementHTML.getAttribute('style') ? elementHTML.getAttribute('style') : '';
                if (mode === 'add')
                  elementHTML.setAttribute('style', currentStyle + ' ' + value);
                else elementHTML.setAttribute('style', currentStyle.replaceAll(value, ''));
              }
            }
          }
        }
      })
    };
    updateStylesClass();
    /**
     Observador que se encarga de llamar a la función updateStylesClass cada vez que la propiedad collectionData
     cambia su valor.
     @name watchCollectionData
     @memberof mounted
     @returns {void}
     */
    watch(() => this.collectionData, () => updateStylesClass());
  }
}
</script>
